// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__cwh8e","upload":"Small_upload__-QA00","imageWrap":"Small_imageWrap__2QTEM","removeBtn":"Small_removeBtn__2fo2_"};